import { render } from "./CashPage.vue?vue&type=template&id=473956ef"
import script from "./CashPage.vue?vue&type=script&lang=js"
export * from "./CashPage.vue?vue&type=script&lang=js"

import "./CashPage.vue?vue&type=style&index=0&id=473956ef&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__